(() => {
  const initialized = new WeakSet();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let motionCleanup = () => {};
  function motion() {
    motionCleanup();
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const targets = [...document.querySelectorAll('[data-reveal]')];
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.remove('reveal-pending'); entry.target.classList.add('is-revealed'); observer.unobserve(entry.target); }
    }), {threshold: 0, rootMargin: '0px 0px -24px 0px'});
    targets.forEach(target => { if (target.getBoundingClientRect().top > innerHeight && !window.Shopify?.designMode) target.classList.add('reveal-pending'); observer.observe(target); });
    const elements = [...document.querySelectorAll('[data-parallax]')];
    const fine = matchMedia('(pointer: fine) and (min-width: 901px)');
    let frame = 0;
    function update() {frame = 0; elements.forEach(element => {
      if (!fine.matches || reduced.matches) return element.style.removeProperty('--parallax-y');
      const box = element.getBoundingClientRect();
      const travel = Math.max(-22, Math.min(22, (innerHeight / 2 - (box.top + box.height / 2)) * .055));
      element.style.setProperty('--parallax-y', `${travel.toFixed(1)}px`);
    });}
    function scroll() {if (!frame) frame = requestAnimationFrame(update);}
    function focus(event) {targets.filter(target => target.contains(event.target)).forEach(target => {target.classList.remove('reveal-pending'); observer.unobserve(target);});}
    addEventListener('scroll', scroll, {passive:true}); addEventListener('resize', scroll, {passive:true}); document.addEventListener('focusin', focus); update();
    motionCleanup = () => {observer.disconnect(); cancelAnimationFrame(frame); removeEventListener('scroll',scroll);removeEventListener('resize',scroll);document.removeEventListener('focusin',focus);targets.forEach(target=>target.classList.remove('reveal-pending'));elements.forEach(element=>element.style.removeProperty('--parallax-y'));};
  }
  function init(root = document) {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (initialized.has(gallery)) return; initialized.add(gallery);
      gallery.querySelectorAll('[data-gallery-button]').forEach(button => button.addEventListener('click', () => {
        const index = Number(button.dataset.galleryButton);
        gallery.querySelectorAll('[data-gallery-panel]').forEach((panel,i)=>{panel.hidden=i!==index;if(i!==index)panel.querySelectorAll('video').forEach(video=>video.pause());});
        gallery.querySelectorAll('[data-gallery-button]').forEach((other,i)=>{other.setAttribute('aria-pressed',String(i===index));other.toggleAttribute('data-active',i===index);});
      }));
    });
    root.querySelectorAll('[data-mobile-menu]').forEach(menu => {
      if (initialized.has(menu)) return; initialized.add(menu);
      const summary = menu.querySelector('summary');
      function close(){menu.open=false;summary.focus();}
      menu.querySelector('[data-menu-close]').addEventListener('click',close);
      menu.addEventListener('toggle',()=>{document.body.classList.toggle('menu-open',menu.open);summary.setAttribute('aria-expanded',String(menu.open));if(menu.open)menu.querySelector('[data-menu-close]').focus();});
      menu.addEventListener('keydown',event=>{
        if(event.key==='Escape'){event.preventDefault();close();}
        if(event.key==='Tab' && menu.open){const focusable=[...menu.querySelectorAll('.mobile-menu-panel a,.mobile-menu-panel button')];const first=focusable[0],last=focusable.at(-1);if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}}
      });
    });
    root.querySelectorAll('[data-variant-picker]').forEach(select => {
      if(initialized.has(select))return;initialized.add(select);
      select.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('variant',select.value);url.searchParams.delete('selling_plan');location.assign(url.href);});
    });
    root.querySelectorAll('[data-purchase-offer]').forEach(offer => {
      if (initialized.has(offer)) return; initialized.add(offer);
      const inputs = [...offer.querySelectorAll('input[name="quantity"][type="radio"]')];
      if (!inputs.length) return;
      const requested = new URL(location.href).searchParams.get('quantity');
      function display(input) {
        offer.querySelector('[data-bundle-count]').textContent = input.value + (input.value === '1' ? ' jar' : ' jars');
        offer.querySelector('[data-bundle-total]').textContent = input.dataset.totalPrice;
      }
      const selected = inputs.find(input => input.value === requested && !input.disabled) || inputs.find(input => input.checked) || inputs[0];
      selected.checked = true; display(selected);
      inputs.forEach(input => input.addEventListener('change', () => {if (input.checked) display(input);}));
    });
    root.querySelectorAll('.aeva-product-form').forEach(form => {
      if(initialized.has(form))return;initialized.add(form);
      form.addEventListener('submit',async event=>{
        event.preventDefault();const button=form.querySelector('[type=submit]');if(button.disabled)return;
        const error=form.querySelector('[data-cart-error]');const original=button.innerHTML;
        button.disabled=true;button.textContent='Adding to cart…';error.hidden=true;
        const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);
        const rootUrl=window.Shopify?.routes?.root || '/';
        try{const response=await fetch(rootUrl+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'},signal:controller.signal});const data=await response.json();if(!response.ok)throw new Error(data.description||'This item cannot be added right now.');location.assign(rootUrl+'cart');}
        catch(failure){error.textContent=failure.name==='AbortError'?'The response is taking longer than expected. Check your cart before trying again.':failure.message;error.hidden=false;button.disabled=false;button.innerHTML=original;}
        finally{clearTimeout(timeout);}
      });
    });
    motion();
  }
  init();reduced.addEventListener('change',motion);
  document.addEventListener('shopify:section:load',()=>init());
  document.addEventListener('shopify:section:unload',()=>{document.body.classList.remove('menu-open');motion();});
})();
